export class Distance {
    private constructor(public millimeters: number) {}

    public static zero(): Distance {
        return new Distance(0);
    }

    public static average(...distances: Distance[]): Distance | null {
        if (distances.length === 0) {
            return null;
        }
        const totalMillimeters = distances.reduce((total, distance) => total + distance.millimeters, 0);
        return Distance.fromMillimeters(totalMillimeters / distances.length);
    }

    public static sum(...distances: Distance[]): Distance {
        return Distance.fromMillimeters(distances.reduce((total, distance) => total + distance.millimeters, 0));
    }

    public get centimeters(): number {
        return this.millimeters / 10;
    }

    public get meters(): number {
        return this.millimeters / 1000;
    }

    public get kilometers(): number {
        return this.meters / 1000;
    }

    public static fromMillimeters(millimeters: number): Distance {
        return new Distance(millimeters);
    }

    public static fromMeters(meters: number): Distance {
        return new Distance(meters * 1000);
    }

    public static fromKilometers(kilometers: number): Distance {
        return new Distance(kilometers * 1000 * 1000);
    }

    public static fromCentimeters(centimeters: number): Distance {
        return new Distance(centimeters * 10);
    }

    public add(other: Distance): Distance {
        return new Distance(this.millimeters + other.millimeters);
    }

    public min(other: Distance): Distance {
        return new Distance(this.millimeters - other.millimeters);
    }

    public div(other: Distance | number): Distance {
        if (typeof other === 'number') {
            return new Distance(this.millimeters / other);
        }
        return new Distance(this.millimeters / other.millimeters);
    }

    public gte(other: Distance): boolean {
        return this.millimeters >= other.millimeters;
    }

    public gt(other: Distance): boolean {
        return this.millimeters > other.millimeters;
    }

    public eq(other: Distance): boolean {
        return this.millimeters === other.millimeters;
    }

    public lt(other: Distance): boolean {
        return this.millimeters < other.millimeters;
    }
}
